export default __webpack_public_path__ + "static/3-80967bd06d1e5574724d4945213afce7.png";